
import { objectDifference } from "@/helpers";
import {
  endorsementMapActions,
  endorsementMapGetters,
  endorsementMapMutations
} from "@/store/modules/endorsements";
import { cloneDeep } from "lodash";
import ActivitiesMixin from "@/components/ActivitiesView/ActivitiesMixin.vue";
import VueWithMixins from "@/helpers/mixins";
import EndorsementMixin from "./EndorsementMixin";
import StatusTag from "@/components/User/StatusTag.vue";

export default VueWithMixins(EndorsementMixin).extend({
  name: "EditEndorsement",
  mixins: [ActivitiesMixin],
  components: { StatusTag },
  async created() {
    try {
      const { data: endorsement = {} } = await this.getEndorsement(
        `${this.endorsementId}?grouped=true`
      );
      if (!endorsement || endorsement.status === "rejected") {
        this.errorMessage = this.resourceNotFoundMsg =
          endorsement?.message || "Error retrieving endorsement data";
        this.resourceNotFound = true;
      } else {
        this.SET_EDIT(endorsement);
      }

      this.initialized = true;
    } catch (error) {
      this.resourceNotFound = true;
      this.initialized = true;
      this.$bugSnagClient.notify(error);
    }
  },
  computed: {
    ...endorsementMapGetters(["getEndorsementById", "editingEndorsement"]),
    endorsement(): any {
      return this.getEndorsementById(this.endorsementId);
    },
    topActionButtonSecondary() {
      return {
        text: "Actions",
        key: "actions",
        subItems: [
          { title: "Cancel", command: "cancel" },
          {
            title: "Add Endorsement Group",
            command: "addEndorsementGroup"
          }
        ]
      };
    },
    updatedFields(): any {
      const edited = this.editingEndorsement;
      const original = this.endorsement;
      return edited && original ? objectDifference(edited, original) : {};
    },
    disablePrimaryToolbar(): boolean {
      return Object.keys(this.updatedFields).length === 0 || !this.formIsValid;
    },
    queryOverride(): any {
      return {
        "data.endorsementId": this.editing?._id,
        activityType: "EndorsementActivity"
      };
    },
    addEndorsementGroupsURL(): string {
      return `/admin/endorsements/${this.endorsementId}/add-group`;
    }
  },
  methods: {
    ...endorsementMapActions([
      "updateEndorsement",
      "getEndorsement",
      "deleteEndorsement"
    ]),
    ...endorsementMapMutations(["SET_EDIT"]),
    onToolbarItemClick(event: string) {
      switch (event) {
        case "update":
          this.promptUpdateConfirmation();
          break;
        case "cancel":
          this.cancelCallback();
          break;
        case "addEndorsementGroup":
          this.$router.push(this.addEndorsementGroupsURL).catch(() => {});
          break;
      }
    },
    async promptUpdateConfirmation(): Promise<void> {
      try {
        this.$modal.show("endorsementSingleEditModal");
      } catch (error) {
        this.$bugSnagClient.notify(error);
      }
    },

    async submit(): Promise<void> {
      try {
        if (this.formIsValid) {
          let fieldsUpdated = cloneDeep(this.updatedFields);
          await this.updateEndorsement({
            update: {
              ...fieldsUpdated,
              action: "update",
              endorsementIds: [this.endorsementId]
            }
          });
          this.successMessage = "Endorsement updated successfully";
          this.$router.push("/admin/endorsements").catch(() => {});
        } else {
          this.errorMessage = "Please correct the errors in the form";
        }
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
    async deleteCallback(): Promise<void> {
      try {
        this.$modal.show("endorsementSingleDeleteModal");
      } catch (error) {
        // do nothing
      }
    },
    async deleteOneEndorsement(): Promise<void> {
      try {
        await this.deleteEndorsement(this.endorsementId);
        this.successMessage = "Endorsement deleted successfully";
        this.$router.push("/admin/endorsements").catch(() => {});
      } catch (error) {
        this.errorMessage = error.message;
      }
    }
  }
});
